const response = await fetch('/config.json');
const config = await response.json();

const Config = {
    apiUrl:  config.apiUrl,
};

export default Config;